@if (store.vm$ | async; as vm) {
  @if (!vm.noResults) {
    <div class="mx-6 divider-b xl:mx-0">
      <ng-container *transloco="let t; prefix: 'profileExtReviews'">
        <h1 class="text-2xl font-bold">{{ t('title', { name: usePronoun ? 'Our' : (name | possessive) }) }}</h1>
        <p class="mb-6! text-steel-70">{{ t('subtext', { name, count: vm.total }) }}</p>
        <rma-profile-external-reviews-list
          rmaShowMore
          [reviews]="vm.reviews"
          [skip]="vm.skip"
          [take]="vm.take"
          [total]="vm.total"
          [queryParamPaging]="false"
          [loading]="vm.loading"
          (showMore)="store.showMore($event)"
          hostClasses="block mt-3"
        />
      </ng-container>
    </div>
  }
}
